import BaseService from './baseService';

class GlobalService extends BaseService {
  async getDynamicApiList() {
    return this.get(`/dynamic-api/list`, {});
  }

  async getDownloadOptions() {
    return this.get(`/download/list`, {});
  }

  async reloadScreenshots(recording_id: string) {
    return this.post(`/recording-list/take-screenshot`, { recording_id });
  }
}

export default new GlobalService();
